<template>
<div id="app">

  <van-notice-bar
    wrapable
    :scrollable="false"
    :text="'二维码审核中，您还可预览 '+ (20-qrData.views_today)+' 次，审核后不限次数。'"
    v-if="qrData.status==0"
    style="position: absolute; top:0;left:0;z-index: 999; width:100%;"
    background="#fff7cc80"
  ></van-notice-bar>

  <div v-if="pageList.length<=0">
    <van-empty description="本页面暂无数据" />
  </div>


<div v-if="previewSetting.isActive" class="preview-simulator" :class="previewSetting.simulator +' simulator_'+ xiuSetting.simulator"  :style="{border:'none',backgroundColor: pageList[previewSetting.activePageIndex].bgColor,animation:previewSetting.bgAnimation}">


  <!-- 当前 -->
  <v-touch v-on:tap="onTapPage" v-on:swipeup="onSwipeNextPage" v-on:swipedown="onSwipePrePage" v-on:swipeleft="onSwipeNextPage" v-on:swiperight="onSwipePrePage" >
  <div class="preview-simulator" :class="previewSetting.simulator" :style="{zIndex:300,position:'absolute'}">
      <div class="player-icon" :style="previewSetting.isBgSoundPlaying ? 'animation-play-state: running;' : 'animation-play-state: paused;'" @click="onPreviewPlayToggle" v-if="pageBgSound.file_url && pageBgSound.file_url !=''"></div>
      <div class="preview-simulator_page" >
          <template v-for="(widgetItem,widgetIndex) in pageList[previewSetting.activePageIndex].widgetList">
            <div class="h5-widget" :style="drag2style(widgetItem.box)" :key="widgetIndex" @click.stop="onPreviewWidgetClick(widgetIndex)">
              <div :class="animate2class(widgetItem.animatePlay,widgetIndex,previewSetting.activePageIndex)" :style="animate2style(widgetItem.animatePlay)" >
                <template v-if="widgetItem.name=='text'">
                  <span v-html="widgetItem.content"></span>
                </template>
                <template v-else-if="widgetItem.name=='image'">
                  <img :src="widgetItem.src" :style="{width:widgetItem.box.width-2 + 'px',height:widgetItem.box.height-2 + 'px',opacity:widgetItem.box.opacity/100}"/>
                </template>
              </div>
            </div>
          </template>
      </div>


  </div>
  </v-touch>

  <!-- 历史 -->
  <div class="preview-simulator" :class="previewSetting.simulator" :style="{zIndex:0,position:'absolute'}" v-if="previewSetting.historyPageIndex !=null">
    <div class="preview-simulator_page">
        <template v-for="(widgetItem,widgetIndex) in pageList[previewSetting.historyPageIndex].widgetList">
          <div class="h5-widget" :style="drag2style(widgetItem.box)" :key="widgetIndex">
            <div :class="animate2class(widgetItem.animatePlay,widgetIndex,previewSetting.historyPageIndex)" :style="animate2style(widgetItem.animatePlay)">
              <template v-if="widgetItem.name=='text'">
                <span v-html="widgetItem.content"></span>
              </template>
              <template v-else-if="widgetItem.name=='image'">
                <img :src="widgetItem.src" :style="{width:widgetItem.box.width-2 + 'px',height:widgetItem.box.height-2 + 'px',opacity:widgetItem.box.opacity/100}"/>
              </template>
            </div>
          </div>
        </template>
    </div>
  </div>


  <div class="page-controller" v-if="previewSetting.playController.showCtrlBtn && !previewSetting.playController.autoPlay">
    <div class="ctrl-btn"><van-button icon="arrow-up" type="info" size="small" plain style="background-color: transparent;" @click="onCtrlPrePage"></van-button></div>
    <div class="ctrl-btn"><van-button icon="arrow-down" type="primary" size="small" plain style="background-color: transparent;" @click="onCtrlNextPage"></van-button></div>
  </div>

  <div class="page-progress">
    <div class="ctrl-btn"  v-if="previewSetting.playController.showCtrlBtn && previewSetting.playController.autoPlay">
      <van-icon name="play-circle-o" size="40" color="#1989fa" @click="onAutoPlayStart" v-if="!previewSetting.playController.defaultPlaying"/>
      <van-icon name="pause-circle-o" size="40" color="#1989fa" @click="onAutoPlayStop" v-if="previewSetting.playController.defaultPlaying"/>
    </div>
    <van-progress :percentage="pageProgress" :show-pivot="false" v-if="previewSetting.playController.showProgress"/>
  </div>
</div>


<van-popup v-model="isShowSwipeHelp" style="background-color: transparent;">
  <div class="animate__animated animate__zoomOut" style="animation-delay: 1.3s;">
    <div class="animate__animated animate__fadeInUp">
      <img src="/static/images/h5editor/swipe-help.png"/>
    </div>
  </div>
</van-popup>




<!-- 背景音乐 -->
<audio autoplay="autoplay" ref="bgAudioRef" preload="auto" :src="pageBgSound.file_url" loop>
  您的浏览器不支持 audio 元素。
</audio>

</div>
</template>

<script>

import Vue from 'vue';
import { Lazyload,Dialog,Toast,ImagePreview} from 'vant';
Vue.use(Lazyload);

import animateClass from './assets/animateClass';
import utils from './assets/utils'



export default {
  name: 'App',
  data:function() {
    let _playController = config.xiuSetting.play_ctrl || {
          showCtrlBtn:false,//是否显示控制按钮
          autoPlay:false,//自动播放
          defaultPlaying:false,//默认播放状态
          loop:0,//播放次数
          notSwipe:false,//禁止滑动翻页
          showProgress:false //显示进度
        };
		return {
      qrData:config.qrData || {},
			pageList:config.pageList || [],
      pageBgSound:config.xiuSetting.bg_sound || {file_url:''},
      xiuSetting:{
        simulator: config.xiuSetting.simulator || 'phone',// pc pad
        width: config.xiuSetting.width || 320,//基准画布 = 内容区
        height: config.xiuSetting.height || 568 //基准画布
      },
      previewSetting:{
        isActive:false,
        isBgSoundPlaying:false,//背景音乐
        simulator:'simulator_sm',
        activePageIndex:0,
        historyPageIndex:null,
        timelineInterval:{},
        count:0,//已预览次数
        bgAnimation:'',//背景色切换动画
        playController: _playController
      },
      randomAnimateCache:{},//随机动画缓存
      bgAnimationKeyframesCache:{},//背景色转场缓存
      isShowSwipeHelp:false,//滑动提示
      isPlayBgSound:false//背景音乐是否播放过
     
		};
	},
  computed: {
    pageTotal(){//页面数
      return this.pageList.length;
    },
    userMaxPages(){
      let _pageTotal = 5;
      switch (config.user.vipLevel) {
        case 'base'://基础版本
          _pageTotal = 15;
          break;
        case 'high':
          _pageTotal = 30;
          break;
        case 'flag':
          _pageTotal = 50;
          break;
        case 'inside':
          _pageTotal = 15;
          break;
        default:
          _pageTotal = 5;
          break;
      }

      return _pageTotal;
    },
    pageProgress(){
      return (this.previewSetting.activePageIndex+1)/this.pageTotal * 100;
    }
  },
	mounted:function(){
    //bind domain
    Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });
	},
	methods: {
		init:function(){
      var that =this;
      this.onPreviewH5();

      //第一次使用滑动提示 且 未禁止滑动
      if(!this.previewSetting.playController.notSwipe)
      {
        let kcxSwipeHelp = utils.storage.get('kcxSwipeHelp');
      
        if(utils.isEmpty(kcxSwipeHelp)){
        
          this.isShowSwipeHelp = true;
          utils.storage.set('kcxSwipeHelp',1);
          setTimeout(function(){
            that.isShowSwipeHelp = false;
          },2300)
        }
      }


		},
    drag2style(box){
      // console.log(drag);
      return {
        width:box.width +'px',
        height:box.height +'px',
        left:box.x +'px',
        top:box.y +'px',
        transform:`rotate(${box.rotate}deg)`,
        zIndex:box.zIndex
      };
    },
    /**
     * 随机动画缓存
     */
    
    /**
     * pageIndex  widgetIndex  用来缓存随机值，每次打开页面随机一次，否则更新中场更新时入场重复播放
     * 
     */
    animate2class(setting,widgetIndex,pageIndex){
      if(setting.name=="none" || setting.name=="" || !setting.name){
        return "";
      }


      //随机
      if(setting.name=="random"){
        //缓存随机值，刷新才会变
        let _cacheKey = 'page'+pageIndex + 'widget'+ widgetIndex + setting.type;
        if(utils.isEmpty(this.randomAnimateCache[_cacheKey])){
          let _typeClass = [];
          for(let i in animateClass){
            if(i<=3){
              continue;
            }
            // 中场随机时，不要out (setting.type=="middle" && animateClass[i].type =='out')
            if(animateClass[i].type==setting.type || setting.type=="click"){
              _typeClass = _typeClass.concat(animateClass[i].list);
            }
          }
          let randomItem = _typeClass[Math.floor(Math.random() * _typeClass.length)];
          this.randomAnimateCache[_cacheKey] = randomItem.css;
        }

        // console.log(this.randomAnimateCache);
        return "animate__animated animate__" + this.randomAnimateCache[_cacheKey];
      }else{
        return "animate__animated animate__" + setting.name;
      }

      
    },
    animate2style(setting){
      //出场无动画时，直接隐藏掉
      if(setting.type=='out' && setting.name=="none"){
        setting.name = 'fadeOut';
        setting.duration = 0;
        setting.delay = 0;
        setting.loop = 1;
      }
      if(setting.name=="none" || setting.name=="" || !setting.name){
        return {};
      }
      return {
        animationDuration:  setting.duration + 's',
        animationDelay:  setting.delay + 's',
        animationIterationCount:  setting.loop == 0 ? 'infinite' : setting.loop,
      }
    },
        /**
     * 初始化当前页面动画
     * 之所以每次切换都要初始化，是因为如果有中场动画或出场动画就会切换掉
     */
    initPageAnimate(type){
      type = type || "in";
      let _previewPage = this.pageList[this.previewSetting.activePageIndex];
  
      for(var j in _previewPage.widgetList){
        if(type=='none'){
          _previewPage.widgetList[j].animatePlay.name = 'none';
          _previewPage.widgetList[j].animatePlay.type = 'in';
          // console.log('_previewPage',_previewPage)
        }else{
          _previewPage.widgetList[j].animatePlay = utils.clone(_previewPage.widgetList[j].animate[type]);
        }
        
      }
  
    },
     /**
     * 停止全部页面动画
     * 之所以每次切换都要初始化，是因为如果有中场动画或出场动画就会切换掉
     */
    stopPageAnimate(){
      for(var i in this.pageList){
        for(var j in this.pageList[i].widgetList){
            this.pageList[i].widgetList[j].animatePlay.name = 'none';
            this.pageList[i].widgetList[j].animatePlay.type = 'in';
        }
      }
    },
    /**
     * 初始化当前页面小部件中场动画到时间轴
     *  #注意# 正式发布时实际不需要每次进行计算，可缓存到变量中，切换时恢复播放状态就可以了
     */
    initPageAnimateTimeline(){
      let pageAnimateTimeline = [];
      let _previewPage = this.pageList[this.previewSetting.activePageIndex];
      for(var j in _previewPage.widgetList){
        let _animate = _previewPage.widgetList[j].animate;
        //中场有动画
        if(_animate.middle.name != "none"){
          // 播放时间
          let _startTime = 0;// _animate.middle.delay;//延迟时间 在css中体现，不需要js控制
          if(_animate.in.name !="none"){//开场时间结束后
            _startTime += _animate.in.loop>0 ? parseFloat(_animate.in.duration) * parseInt(_animate.in.loop) : parseFloat(_animate.in.duration);
            _startTime += parseFloat(_animate.in.delay);
          }

      

          
          //转为毫秒
          if(_startTime>0){
            _startTime = _startTime.toFixed(1); //时间轴速度，startTime限制在 1位小数，就会全部是100的倍数
            _startTime *= 1000;
          }

          pageAnimateTimeline.push({
            startTime:_startTime,
            widgetIndex:j,
            animatePlay:utils.clone(_animate.middle),
            // playStatus:'ready'//播放状态 ready待播放 play 已播放
          });
          
        }
      }

      return pageAnimateTimeline;

    },
    //播放时间轴
    pageAnimateTimelinePlay(){
      let that = this;
      let pageAnimateTimeline = this.initPageAnimateTimeline();//时间轴信息
      if(utils.isEmpty(pageAnimateTimeline)){
        this.pagePlayEnd();
        return;
      }
    // console.log('pageAnimateTimeline',pageAnimateTimeline);

      let _previewPageWidgetList = this.pageList[this.previewSetting.activePageIndex].widgetList;

      //最后时间
      let lastTime = 0;//pageAnimateTimeline[pageAnimateTimeline.length-1].startTime;
      for(var i in pageAnimateTimeline){
        if(pageAnimateTimeline[i].startTime >lastTime){
          lastTime = pageAnimateTimeline[i].startTime;
        }
      }
      // 动画时间轴
      let speedTime = 0;
   
    
      that.previewSetting.timelineInterval[that.previewSetting.activePageIndex] = setInterval(function(){

        for(var i in pageAnimateTimeline){
          if(pageAnimateTimeline[i].startTime == speedTime){
             //执行动画
            let _payload =  pageAnimateTimeline[i];
            _previewPageWidgetList[_payload.widgetIndex].animatePlay = utils.clone(_payload.animatePlay);
            // console.log(speedTime, _previewPageWidgetList[_payload.widgetIndex].animatePlay);
          }
        }
  // console.log(speedTime , lastTime);
        //自然停止
        if(speedTime >= lastTime){
          that.pageAnimateTimelineStop();
          that.pagePlayEnd();
        }
        // console.log('PageIndex=',that.previewSetting.activePageIndex,speedTime);

        speedTime +=100;
        
      }, 100);//时间轴速度，startTime限制在 1位小数，就会全部是100的倍数

      // console.log('timelineInterval',utils.clone(timelineInterval));

    },
    //停止一个页面的时间轴
    pageAnimateTimelineStop(){
      let pageIndex = this.previewSetting.activePageIndex;
      //  console.log('pageIndex TimelineStop',pageIndex);

      let timelineInterval = this.previewSetting.timelineInterval[pageIndex];

      if(!utils.isEmpty(timelineInterval)){
        clearInterval(timelineInterval);
      }
      return true;
    },
    /**
     * 
     * 当前页面播放完触发
     * 1.无中场动画时
     * 2.中场动画播放完时
     * 停留N秒后自动下一页
     * 
     */
    pagePlayEnd(){
      let that = this;
      //  console.log('pagePlayEnd',this.previewSetting.activePageIndex , this.pageTotal-1)
      //到最后一页记一次播放次数
      if(this.previewSetting.activePageIndex == this.pageTotal-1){
        this.previewSetting.count ++;
      } 

      // console.log('previewSetting', this.previewSetting.count);

      //自动播放
      if(this.previewSetting.playController.autoPlay && 
        (this.previewSetting.playController.loop==0 || this.previewSetting.count < this.previewSetting.playController.loop)
      ){
        setTimeout(function(){
          if(that.previewSetting.playController.defaultPlaying){
            that.onNextPage();
          }
        },2000)
      }

    },
    onAutoPlayStart(){
      let that = this;

     // 触发：尝试自动播放
     if(! this.tryAutoPlayBgSound()){
        this.onPreviewPlayToggle('play');
     }


      this.previewSetting.playController.defaultPlaying = true;
      setTimeout(function(){
        if(that.previewSetting.playController.defaultPlaying){
          that.onNextPage();
        }
      },2000)
    },
    onAutoPlayStop(){

      // 触发：尝试自动播放
      // this.tryAutoPlayBgSound();

      this.onPreviewPlayToggle("stop");
      
      
      this.previewSetting.playController.defaultPlaying = false;
    },
    //预览
    /**
     * 1.创建一个不同页面时间轴记录动画时间信息
     * 2.in已经初始化，把中场动画记录到时间轴上，到点切换
     * 3. 划走下一页时，停止当前时间轴，切换出场动画，无动画直接隐藏
     *  
     */
    onPreviewH5(){
      var that = this;
      
      this.previewSetting.isActive = true;
      this.previewSetting.activePageIndex = 0;
      //当前页面动画初始化
      this.initPageAnimate('in');
      
      this.pageAnimateTimelinePlay();

      // this.previewSetting.count ++;
 
      //  this.$message.info({
      //   content:'第' + ( this.previewSetting.activePageIndex +1 ) + '页',
      //   duration:1
      // });
      //背景音乐
      // this.onPreviewPlayToggle('play');

      if(utils.is_weChat()){
        // 触发：尝试自动播放
        document.addEventListener("WeixinJSBridgeReady", function () {
          // console.log('WeixinJS')
          that.tryAutoPlayBgSound();
        });
        
      }



    },
    onPreviewPlayToggle(action){
// console.log('onPreviewPlayToggle',action)
      var that = this;
      if(utils.isEmpty(this.pageBgSound.file_url)){
        return;
      }
      if(action=="stop"){
        this.bgPause();//暂停
        this.previewSetting.isBgSoundPlaying = false;
        return;
      }else if(action=="play"){
        this.previewSetting.isBgSoundPlaying = true;
        // if(this.bgPlaySetUrl(this.pageBgSound.file_url)){
        //   this.bgPlay();
        // }

        this.bgPlay();

        //判断未能自动播放时，暂停
        setTimeout(function(){
          if(that.bgIsPaused()){
            that.onPreviewPlayToggle("stop");
          }
        },1500)
      }else{//切换
        if(this.previewSetting.isBgSoundPlaying){
          this.onPreviewPlayToggle("stop");
        }else{
          this.onPreviewPlayToggle("play");
        }
      }
  

    },
    /**
     * 1 小部件点击时动作
     * 2 点击动画处理
     */
    onPreviewWidgetClick(widgetIndex){

      let _previewPageWidgetList = this.pageList[this.previewSetting.activePageIndex].widgetList;

      let _widget =_previewPageWidgetList[widgetIndex]
      // console.log(_widget.clickAction);


      //执行点击动画
      if(_widget.animate.click.name !="none"){
        _widget.animatePlay = utils.clone(_widget.animate.click);
        //执行后恢复
        if(_widget.animatePlay.loop >0 ){

          let _timeOut = (_widget.animatePlay.duration * _widget.animatePlay.loop) + _widget.animatePlay.delay;

          //out动画要重新入场，其它为 none这样每次点击都能播放
          setTimeout(function(){
            _widget.animatePlay.name = _widget.animatePlay.name.indexOf('Out') !=-1 ? "fadeIn" : "none";
            _widget.animatePlay.duration = 1;
            _widget.animatePlay.delay = 0;
            _widget.animatePlay.loop = 1;
          },_timeOut * 1000);

        }
      }


      //执行动作
      this.execClickAction(_widget.clickAction);
      

    },
    
    // clickAction 格式：
      // action:"none", //none page link tel message 后期[video music]换背景音乐等
      // page:{index:0},
      // link:{
      //     link: '',//url
      //     path: '',//小程序页面
      //     appId: '' //小程序appId
      // },
      // message:'',
      // tel:''
    execClickAction(clickAction){

      let that = this;

      if(clickAction.action =="none"){
        return; 
      }

      //切换页面
      if(clickAction.action=="page"){
        this.onNextPageToIndex(clickAction.page.index);
        return;
      }

      //跳转链接
      if(clickAction.action=="link"){
        if(utils.isEmpty(clickAction.link.link)){
          return;
        }

        //网页跳转link
        var a = document.createElement('a');
        a.href = clickAction.link.link;
        var target_href = document.createAttribute("target");
        target_href.nodeValue = "_blank";
        a.setAttributeNode(target_href);
        a.click();

        return;
      }
      //打电话
      if(clickAction.action=="tel"){
        if(utils.isEmpty(clickAction.tel)){
          return;
        }
        location.href="tel://"+clickAction.tel;
        return;
      }
      //message
      if(clickAction.action=="message"){
        if(utils.isEmpty(clickAction.message)){
          return;
        }
     

        Dialog.alert({
          title: '提示',
          message: clickAction.message,
          closeOnClickOverlay:true
        }).then(() => {
          // on close
        }).catch(() => {
          // on cancel
        });
        
        
        return;
      }
    },
    //关闭预览
    onPreviewH5Close(){

      this.pageAnimateTimelineStop();//先停止当前页面时间轴
      this.stopPageAnimate();//停止全部动画
      this.previewSetting.isActive = false;
      this.previewSetting.activePageIndex = 0;
      this.previewSetting.historyPageIndex = null;

       this.onPreviewPlayToggle('stop');//暂停背景音乐
    },
    //切换预览屏
    onTogglePVS(simulator){
      this.previewSetting.simulator = simulator;
    },
    onPrePage(){
   
      this.pageAnimateTimelineStop();//先停止当前页面时间轴
      //出场动画
      if( this.pageTotal>1){

        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }

      //上页 同步入场
      if(this.previewSetting.activePageIndex ==0){
        this.previewSetting.activePageIndex = this.pageTotal-1;
      }else{
        this.previewSetting.activePageIndex -=1;
      }

      //当前页面动画初始化
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴

      // this.$message.info({
      //   content:'第' + ( this.previewSetting.activePageIndex +1 ) + '页',
      //   duration:1
      // });
      
    },
    //背景转场动画生成
    bgAnimationKeyframes(){

      if(this.previewSetting.historyPageIndex==null){
        return;
      }

      let _name = 'bgKframes_'+ this.previewSetting.activePageIndex + this.previewSetting.historyPageIndex;

      let _formColor = this.pageList[this.previewSetting.historyPageIndex].bgColor;
      let _toColor = this.pageList[this.previewSetting.activePageIndex].bgColor;
      //相等无动画
      if(_formColor == _toColor){
        return ;
      }

      if(utils.isEmpty(this.bgAnimationKeyframesCache[_name])){


        this.bgAnimationKeyframesCache[_name] = true;

        let style = document.createElement('style');
          style.setAttribute('type', 'text/css');
          document.head.appendChild(style);
          let sheet = style.sheet;
          //根据每一页添加不同的keyframes
          sheet.insertRule(
            `@keyframes ` + _name +`{
                from {
                  background:` + _formColor +`;
                }
              to {
                  background:` + _toColor +`;
                }
              }`
        ,0);
      }

      this.previewSetting.bgAnimation = _name + ' 1.5s';

    //  console.log(this.previewSetting.bgAnimation )

    },
    /**
     * historyPageIndex 切换出场
     */
    onNextPage(){
      //  console.log('onNextPage')


      this.pageAnimateTimelineStop();//先停止当前页面时间轴

      //出场动画
      if( this.pageTotal>1){
        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }
      


      //下页 同步入场
      if(this.previewSetting.activePageIndex >= this.pageTotal-1){
        this.previewSetting.activePageIndex = 0;
      }else{  
        this.previewSetting.activePageIndex +=1;
      }

      
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴
      this.bgAnimationKeyframes();
      
      // this.$message.info({
      //   content:'第' + (this.previewSetting.activePageIndex+1) + '页',
      //   duration:1
      // });

    },
    /**
     * 切换到指定页面
     */
    onNextPageToIndex(index){
      
      index = parseInt(index);
      if(isNaN(index)){
        return;
      }
      // console.log('onNextPageToIndex',index)

      this.pageAnimateTimelineStop();//先停止当前页面时间轴

      //出场动画
      if( this.pageTotal>1){
        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }
      
  

      //下页 同步入场
      if(index > this.pageTotal-1){
        this.previewSetting.activePageIndex = 0;
      }else{  
        this.previewSetting.activePageIndex = index;
      }

      
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴
      
      // this.$message.info({
      //   content:'第' + (index+1) + '页',
      //   duration:1
      // });

    },
    tryAutoPlayBgSound(){
      // 触发：尝试自动播放
      if(!this.isPlayBgSound && !this.previewSetting.isBgSoundPlaying){
        this.isPlayBgSound = true;
        this.onPreviewPlayToggle('play');
        return true;
      }
      return false;
    },
    //点击页面
    onTapPage(){
       // 触发：尝试自动播放
      this.tryAutoPlayBgSound();
    },
    //滑动
    onSwipeNextPage(){
      
      // 触发：尝试自动播放
      this.tryAutoPlayBgSound();
      


      if(this.previewSetting.playController.notSwipe){//禁止滑动
        return ;
      }
      this.onNextPage();
    },
    onSwipePrePage(){
      
      // 触发：尝试自动播放
      this.tryAutoPlayBgSound();
      
      if(this.previewSetting.playController.notSwipe){
        return ;
      }
      this.onPrePage();
    },
    //点击
    onCtrlNextPage(){
      
      // 触发：尝试自动播放
      this.tryAutoPlayBgSound();
      

      this.onNextPage();
    },
    onCtrlPrePage(){
      
      // 触发：尝试自动播放
      this.tryAutoPlayBgSound();
   
      this.onPrePage();
    },
    //背景音乐
    bgPlayer(){
      
      return this.$refs.bgAudioRef;
			// return document.getElementById("bgAudioRef");
		},
    // bgPlaySetUrl(playUrl){
    //   if(!utils.isEmpty(playUrl)){
    //      this.bgSound.audioSrc = playUrl;
    //      return true;
    //   }
    //   return false;
    // },
    bgPlay(){
      this.$nextTick(()=>{
        this.bgPause();
        this.bgPlayer().play();
      });
		},
		bgPause(){
      if(this.bgIsPaused()){
        return ;
      }
      this.$nextTick(()=>{
        this.bgPlayer().pause();
      });
			
		},
    //是否停止播放了
    bgIsPaused(){
			return this.bgPlayer().paused;
		},



	}
}
</script>


<style scoped>
.h5-widget{
  position: absolute;
  /* 占位 border */
  border:1px dashed transparent;
  /* overflow: hidden; */
}
/* 预览 */
.preview-simulator{
  /* border:2px dashed #999; */
  /* margin:0 auto;
  overflow: hidden; */
  position: relative;
  width:100%;
  height:100%;
  overflow: hidden;
  /* background: red; */
}
/* .preview-simulator.simulator_lg{
    width: 375px;
    height: 812px;
}
.preview-simulator.simulator_md{
    width: 375px;
    height: 667px;
} */
/* .preview-simulator.simulator_sm{
    width: 320px;
    height: 568px;
} */

/* .preview-simulator_page{
    position: absolute;
    width: 320px;
    height: 568px;
    margin-left:-160px;
    margin-top:-284px;
    top: 50%;
    left: 50%;
} */
/* 最佳内容区 */
.preview-simulator .preview-simulator_page{
    position: absolute;
    top:  50%;
    left: 50%;
    margin-top: -227.5px;
    margin-left: -160px;
    height: 455px;
    width: 320px;
    /* border:1px solid red; */
}

/* pad 尺寸适配 */
.simulator_pad .preview-simulator_page{
  width: 768px;
  height: 1024px;
  margin-left: -384px;
  margin-top:-512px;
}

/* pc 尺寸适配 */
.simulator_pc .preview-simulator_page{
  width: 1024px;
  height: 768px;
  margin-left: -512px;
  margin-top:-384px;
  /* border:1px dashed #ccc; */
}


 /*竖屏 css*/
/* @media screen and (orientation: portrait) {
  .preview-simulator_page{
    position: absolute;
      width: 320px;
      height: 568px;
      border:1px dashed red;
      top: 50%;
      left: 50%;
      margin-left:-160px;
      margin-top:-284px;
      
  }
} */
/*横屏 css*/
 /* @media screen and (orientation: landscape) {
  .preview-simulator_page{
    position: absolute;
      height: 320px;
      width: 568px;
      border:1px dashed blue;
      top: 50%;
      left: 50%;
      margin-left:-284px;
      margin-top:-160px;
  }
}  */


/* .preview-simulator.simulator_lg .preview-simulator_page{
    top: 122px;
    height: 812px;
    left: 50%;
    margin-left: -160px;
}
.preview-simulator.simulator_md .preview-simulator_page{
    top: 49.5px;
    height: 568px;
    left: 50%;
    margin-left: -160px;
} */
/* .preview-simulator.simulator_sm .preview-simulator_page{
    top: 50%;
    left: 50%;
    margin-left:-160px;
    margin-top:-284px;
    height: 568px;

} */

.preview-simulator_page p {
    margin: 5px 0;
    font-size: 14px;
}
/* 播放背景音乐 */
@-webkit-keyframes rotating{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}
@keyframes rotating{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}
.preview-simulator .player-icon{
	position: absolute;
    z-index: 200;
    width: 30px;
    height: 30px;
	  right: 16px;
    top: 16px;
    border-radius: 15px;
    background-image: url(/static/images/h5editor/play-icon.svg);
    background-size: contain;
    background-repeat: no-repeat;
	-webkit-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
	/* animation-play-state: running; */
	/* animation-play-state: paused; */
}




/*兼容ueditor表格*/
.preview-simulator table ,.h5-pagemain table{
  width:100%;
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
.preview-simulator td, .preview-simulator th,.h5-pagemain td,.h5-pagemain th {
    padding: 5px 10px;
    border: 1px solid #DDD;
}

.page-controller{
  position: absolute;
  bottom: 10px;
  left:10px;
  z-index: 1000;

	padding-bottom: constant(safe-area-inset-bottom);
	padding-bottom: env(safe-area-inset-bottom);
}
.page-controller .ctrl-btn{
  margin: 5px 0;
}
.page-progress{
  position: absolute;
  bottom: 0px;
  left:0px;
  width:100%;
  z-index: 1000;

	padding-bottom: constant(safe-area-inset-bottom);
	padding-bottom: env(safe-area-inset-bottom);
}
.page-progress .ctrl-btn{
  margin:5px;
}
</style>
